import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface AboutSubNavItem {
  label: string;
  to: string;
  icon: string;
}

export default function AboutSubNav() {
  const { t } = useTranslation();
  const aboutSubNav = t("about.subNav", { returnObjects: true }) as unknown as AboutSubNavItem[];

  return (
    <div className="bg-background-100 border-b border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="flex items-center -mb-px overflow-x-auto gap-1 scrollbar-hide">
          {aboutSubNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-2 px-5 py-4 text-sm font-medium whitespace-nowrap border-b-2 transition-colors cursor-pointer ${
                  isActive
                    ? "border-primary-500 text-primary-600"
                    : "border-transparent text-foreground-600 hover:text-foreground-900 hover:border-background-300"
                }`
              }
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-[13px]`} />
              </span>
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}